//#region Import
import { Fragment } from "react";
import { useTranslation } from "@1f/react-sdk";

//Vapor Components
import Modal from "@vapor/react-material/Modal";
import VaporTag from "@vapor/react-custom/VaporTag";
import Grid from "@vapor/react-material/Grid";
import Typography from "@vapor/react-extended/ExtendedTypography";
import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

//Custom styles
import {
    chipGreen,
    chipRed,
    modalStyleUltraLarge,
} from "../businessLogic/styles";
//#endregion

export const ModalAnagrafica = ({ show, onClose, anagrafica, allProvince, allComuni }) => {
    const { t } = useTranslation();

    if (!anagrafica) return null;

    const handleModalClose = () => {
        onClose();
    };    

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleDateString();
    };

    const InfoRow = ({ label, value }) => (
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={4}>
                <Typography variant="body2" color="text.secondary" fontWeight="bold">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={8}>
                <Typography variant="body2">
                    {value || "-"}
                </Typography>
            </Grid>
        </Grid>
    );

    return (
        <Fragment>
            <Modal
                key="anagraficaModal"
                aria-labelledby="modal-anagrafica-title"
                aria-describedby="modal-anagrafica-description"
                open={show}
                onClose={handleModalClose}
                onBackdropClick={handleModalClose}
            >
                <Box sx={modalStyleUltraLarge}>
                    <Stack
                        direction="column"
                        spacing={0}
                        justifyContent="left"
                        alignItems="left"
                    >
                        <ExtendedTypography
                            variant="titleSmall"
                            color="primary.main"
                            sx={{ p: 2, pl: 3 }}
                        >
                            {`Dettagli Anagrafica - ${anagrafica.denominazione || ""}`}
                        </ExtendedTypography>
                        <Divider orientation="horizontal" flexItem />
                        
                        <Box sx={{ p: 3, maxHeight: '70vh', overflowY: 'auto' }}>
                            <Stack spacing={3}>
                                {/* Sezione Dati Anagrafici */}
                                <div>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        Dati Anagrafici
                                    </Typography>
                                    <InfoRow label="Denominazione" value={anagrafica.denominazione} />
                                    <InfoRow label="Codice Fiscale" value={anagrafica.cf} />
                                    <InfoRow label="Partita IVA" value={anagrafica.pIva} />                                    
                                    {!anagrafica.isPg &&
                                        <>
                                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                                <Grid item xs={4}>
                                                    <Typography variant="body2" color="text.secondary" fontWeight="bold">
                                                        Persona Politicamente Esposta
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    {anagrafica.isPep ? (
                                                        <VaporTag variant="standard" label="Sì" sx={chipGreen} />
                                                    ) : (
                                                        <VaporTag variant="standard" label="No" sx={chipRed} />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                    <InfoRow label="Data Identificazione" value={formatDate(anagrafica.identifiedOn)} />
                                </div>

                                <Divider />

                                {/* Sezione Indirizzo */}
                                <div>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        Indirizzo
                                    </Typography>
                                    <InfoRow label="Via" value={anagrafica.addrIndirizzo} />
                                    <InfoRow label="Numero Civico" value={anagrafica.addrN} />
                                    <InfoRow label="CAP" value={anagrafica.addrCap} />
                                    <InfoRow label="Città" value={allComuni?.find((c) => c.id === anagrafica.addrComuneId)?.nome || "-"} />
                                    <InfoRow 
                                        label="Provincia" 
                                        value={allProvince?.find((p) => p.id === anagrafica.addrProvinciaId)?.nome || "-"} 
                                    />                                    
                                </div>                                                                
                            </Stack>
                        </Box>
                    </Stack>

                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{ p: 1, mt: 1, bgcolor: "#F2F5F8" }}
                        justifyContent="right"
                        alignItems="right"
                    >
                        <Button variant="contained" size="small" onClick={handleModalClose}>
                            {t("actions.chiudi")}
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </Fragment>
    );
}